/**
 * Form interactions
 * Add/remove active class on select elements
 */

export function initFormSelectActive() {
  const selects = document.querySelectorAll("select.form-input");
  if (!selects.length) return;

  document.addEventListener("click", (e) => {
    const targetSelect = e.target.closest("select.form-input");

    if (targetSelect) {
      // Jangan add active jika yang diklik adalah option
      if (e.target.tagName === "OPTION") return;

      selects.forEach((select) => {
        select.classList.toggle("active", select === targetSelect);
      });
    } else {
      selects.forEach((select) => {
        select.classList.remove("active");
      });
    }
  });

  selects.forEach((select) => {
    select.addEventListener("change", () => {
      select.classList.remove("active");
    });
  });
}

function updateDropdownShadow(dropdown) {
  const sideHead = dropdown.querySelector(".side-head");
  const filterList = dropdown.querySelector(".filter-list");
  if (!sideHead || !filterList) return;

  const totalHeight = sideHead.getBoundingClientRect().height + filterList.getBoundingClientRect().height;
  dropdown.style.setProperty("--dropdown-shadow", `${totalHeight}px`);
}

export function initDropdownSelect() {
  const dropdowns = document.querySelectorAll(".dropdown-select");
  if (!dropdowns.length) return;

  dropdowns.forEach((dropdown) => {
    const button = dropdown.querySelector(".side-head");

    if (button) {
      button.setAttribute("aria-expanded", dropdown.classList.contains("active") ? "true" : "false");
    }

    if (dropdown.closest(".product-archive-filter-form")) {
      updateDropdownShadow(dropdown);

      const filterList = dropdown.querySelector(".filter-list");
      if (filterList && "ResizeObserver" in window) {
        const ro = new ResizeObserver(() => {
          updateDropdownShadow(dropdown);
        });
        ro.observe(filterList);
        ro.observe(dropdown.querySelector(".side-head"));
      }
    }
  });

  document.addEventListener("click", (e) => {
    const targetButton = e.target.closest(".dropdown-select .side-head");
    const targetDropdown = e.target.closest(".dropdown-select");

    dropdowns.forEach((dropdown) => {
      const button = dropdown.querySelector(".side-head");

      if (targetButton && dropdown === targetDropdown) {
        const isOpening = !dropdown.classList.contains("active");
        dropdown.classList.toggle("active", isOpening);
        if (button) {
          button.setAttribute("aria-expanded", isOpening ? "true" : "false");
        }
        if (dropdown.closest(".product-archive-filter-form")) {
          updateDropdownShadow(dropdown);
        }
      } else {
        dropdown.classList.remove("active");
        if (button) {
          button.setAttribute("aria-expanded", "false");
        }
      }
    });
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;

    dropdowns.forEach((dropdown) => {
      dropdown.classList.remove("active");

      const button = dropdown.querySelector(".side-head");
      if (button) {
        button.setAttribute("aria-expanded", "false");
      }
    });
  });

  document.querySelectorAll(".product-archive-filter-form input[type='checkbox']").forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      const form = checkbox.form;
      if (form) {
        form.submit();
      }
    });
  });
}
